import { useEffect } from 'react'
import type { RefObject } from 'react'

/**
 * A hook at that calls a function when clicked outside of el ref.
 * @param el - a react reference to an element to be closed when clicking out side of.
 * @param open - current state of whether its open or not.
 * @param fn - a function to call when clicking out side of.
 */
export default function useClickOut(el: RefObject<HTMLElement>, open: boolean, fn: (e: MouseEvent) => void) {
  const handleWindowClick = (e: MouseEvent) => {
    if (!open) {
      return
    }

    if (!el.current) {
      return
    }

    const target = e.target as Node | null
    if (!target || !document.body.contains(target)) {
      return
    }

    if (target.isSameNode(el.current)) {
      return
    }

    if (el.current.contains(target)) {
      return
    }

    fn(e)
  }

  useEffect(() => {
    window.addEventListener('mouseup', handleWindowClick)
    return () => window.removeEventListener('mouseup', handleWindowClick)
  })
}
